const useCharHide = () => {
  const mapCharToHiddenChar = (str, index, chr) => {
    let char = '';
    if (index === 9) return str;
    if (!str) return 'XXXXXXXXX';
    for (let i = 0; i < 9 - index; i++) { char += chr }
    if (index > str.length - 1) return str;
    return char + str.substring(9 - index);
  };

  return {
    mapCharToHiddenChar: mapCharToHiddenChar,
  };

};

export default useCharHide;